import { useAppDispatch, useAppSelector } from "@app/hooks";
import { RootState } from "@app/store";
import { pollingInterval } from "@features/tenant-selector/types";
import { FC, ReactElement, useEffect, useMemo } from "react";
import { useInventoryQuery } from "../api";
import { setInventory } from "../slice";


const InventoryProvider: FC = ({ children }) => {
  const dispatch = useAppDispatch();

  const userTenant = useAppSelector((state: RootState) => state.userTenant);
  const tenant = useAppSelector((state: RootState) => state.tenant);

  const currentTenant = useMemo(() => tenant.currentTenant || userTenant, [tenant.currentTenant, userTenant]);

  const {
    currentData: inventory,
  } = useInventoryQuery({
    userTenantId: currentTenant?.tenant_id || '',
  }, {
    skip: !userTenant?.tenant_id,
    pollingInterval,
  });

  useEffect(() => {
    dispatch(setInventory(inventory));
  }, [dispatch, inventory]);

  return children as ReactElement;
}

export default InventoryProvider;